
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"70","height":"70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35 0a35 35 0 110 70 35 35 0 010-70zm-4.36 41.905l-7.775-7.78a3.002 3.002 0 00-4.245 4.245l9.9 9.9a2.99 2.99 0 004.245 0l20.5-20.505a2.998 2.998 0 00.02-4.26 2.999 2.999 0 00-4.26.015L30.64 41.905z","fill":"#80EAB0"}})])
          )
        }
      }
    